<template>
	<Row class="lg:!pt-[64px] pb-0">
		<Container>
			<h2
				class="title text-center text-[24px] lg:text-[36px] mb-[16px] text-white"
			>
				{{ title }}
			</h2>

			<p class="text-center text-base text-slate-300 mb-[32px]">
				{{ description }}
			</p>

			<div class="flex flex-wrap gap-[16px] justify-center">
				<NuxtLink
					:key="item.id"
					:href="`/category/${item.slug}/`"
					class="category-btn"
					v-for="item in categories.sort((a, b) => b.count - a.count).slice(0, 6)"
				>
					<span class="category-btn-wrapper min-w-[300px] py-[16px] px-[20px]">
						{{ item.name }}

						<svg
							class="ml-auto"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9 4.5L16.5 12L9 19.5"
								stroke="white"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</span>
				</NuxtLink>
			</div>
			<hr class="mt-[80px] border-slate-700" />
		</Container>
	</Row>
</template>

<script setup>
defineProps(["categories", "title", "description"]);
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.category-btn {
	border-radius: 16px;
	text-transform: capitalize;
	display: flex;
	align-items: center;
	position: relative;
	padding: 1px;
	overflow: hidden;
	&.router-link-active {
		background: $slate-100;
		color: $slate-900;
	}
	&-wrapper {
		border-radius: 16px;
		overflow: hidden;
		position: relative;
		z-index: 1;
		height: 100%;
		background: $slate-800;
		display: flex;
	}

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: calc(100%);
		height: calc(100%);
		@include gradient-primary;
	}
}

.category-btn-wrapper {
	color: white;
}
</style>
